import { render, staticRenderFns } from "./RelatedProducts.vue?vue&type=template&id=fe472df4&scoped=true&"
import script from "./RelatedProducts.vue?vue&type=script&lang=js&"
export * from "./RelatedProducts.vue?vue&type=script&lang=js&"
import style0 from "./RelatedProducts.vue?vue&type=style&index=0&id=fe472df4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe472df4",
  null
  
)

export default component.exports